<template>
    <div class="field" v-show="visible">
      <div class="field-selection-wrapper checkbox-selection-wrapper">
        <question-attributes :colors="colors" :field="field"></question-attributes>
        <div class="field-selection-container checkbox-selection-container">
          <div
            class="checkbox-selection"
            v-for="(option, idx) in field.answerOptions"
            v-bind:key="field.id + '_' + idx"
            @click="setStatus(option, option.selected)">
            <div class="checkbox"
                 :class="{selected: option.selected}"
                 :style="option.selected ? checkboxStyle : {}"
            ></div>
            <span class="label" :style="{color: colors.baseColor}">{{ option.value }}</span>
          </div>
          <div class="error" v-if="field.invalid && !totalSelected">This field is required</div>
        </div>
      </div>
    </div>
</template>

<script>
import Vue from 'vue'
import Field from './Field'
import { EventBus } from '../../EventBus'

export default {
    name: 'RadioField',
    extends: Field,
    props: ['colors'],
    computed: {
        checkboxStyle() {
            return {
                backgroundColor: this.colors.highlightColor
            }
        }
    },
    methods: {
        setStatus (option) {
          const previousValue = option.selected
          EventBus.$emit('answerOptionIdClicked', JSON.stringify({answerOptionId: option.id, newValue: !previousValue}))

          if (!previousValue) return Vue.set(option, 'selected', true)
            if (previousValue) return Vue.set(option, 'selected', false)
        }
    }
}
</script>

<style scoped>
    .checkbox-selection-container {
        display: flex;
        flex-wrap: wrap;
    }
    .checkbox-selection {
        flex: 1 0 50%;
        width: 50%;
        max-width: calc(50% - 34px);
        margin: 0 10px 10px 0;
        border: solid 2px #e6e6e6;
        padding: 10px;
        box-shadow: 0 0 4px rgba(0, 0, 0, 0.14);
    }
    .checkbox {
      display: inline-block;
      vertical-align: middle;
      width: 28px;
      height: 28px;
      border: solid 1px #90919e;
      margin-right: 10px;
      position: relative;
    }
    .checkbox.selected {
        border: solid 1px #00aef1;
    }
    .checkbox.selected:after {
        content: "";
        background: #fff;
        width: 12px;
        height: 12px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .label {
        font-size: 13px;
        font-weight: 600;
    }
</style>



// WEBPACK FOOTER //
// node_modules/survey-fields/src/Question/Fields/CheckBoxField.vue